// Ana sayfa gorsel arka plani: "header" yalniz ust bant, "full" tum ana sayfanin arkasi. Varsayilan eski davranis (bant + cover).
const imageModeOf = (h) => (h && h.style === "image" && h.imageUrl ? (h.imageMode === "full" ? "full" : "header") : null);

const imageBackground = (h, overlay) => {
    const p = (h && h.imagePosition) || {};
    const pos = `${typeof p.x === "number" ? p.x : 50}% ${typeof p.y === "number" ? p.y : 50}%`;
    const contain = h.imageFit === "contain";
    return {
        backgroundImage: `${overlay}, url(${h.imageUrl})`,
        backgroundPosition: `center, ${pos}`,
        backgroundSize: `100% 100%, ${contain ? "contain" : "cover"}`,
        backgroundRepeat: "no-repeat",
        // sigdirmada bos kalan alan secilen renk ya da tema rengiyle dolar
        ...(contain ? { backgroundColor: h.color || "var(--button-color, #4f46e5)" } : {}),
    };
};

module.exports = { imageModeOf, imageBackground };



// WEBPACK FOOTER //
// ./src/utils/shell/homeBackground.js